import track from '../../services/track';

const trackDwellTime = () => {
  try {
    if (window && window.sessionStorage) {
      const sessionStartTimeParam = 'sessionStartTime';
      const sessionStartEventFiredParam = 'sessionStartEventFired';
      const sessionTimeThreshold = 35;

      if (sessionStorage.getItem(sessionStartEventFiredParam)) {
        return false;
      }

      const currentTimestamp = Math.round(new Date().getTime() / 1000);

      let sessionStartTime = parseInt(
        sessionStorage.getItem(sessionStartTimeParam)
      );
      if (!sessionStartTime) {
        sessionStartTime = currentTimestamp;
        sessionStorage.setItem(sessionStartTimeParam, sessionStartTime + '');
      }

      const secondsToTimeout =
        sessionTimeThreshold - (currentTimestamp - sessionStartTime);

      setTimeout(function() {
        track('session started');
        try {
          sessionStorage.setItem(sessionStartEventFiredParam, '1');
        } catch {
          // Ignore session storage errors
        }
      }, secondsToTimeout * 1000);
    }
  } catch {
    // Ignore, not a big deal if this fails
  }
};

trackDwellTime();

export default function() {
  return '';
}
